<template>
  <div class="col-md-12">
    <h2>Terms Of Service</h2>
    <p class="sub-text mb-4">
      A full copy is below and will also be sent to the email provided.
    </p>
    <ul>
      <li>12 month contract (tiered pricing)</li>
      <li>Charged monthly based on the transaction volume</li>
      <li>You are responsible for the damage to the kiosk</li>
      <li>Early cancellation (only after 4 months)</li>
      <li>Return shipping Fee of $399</li>
      <li>
        Support: Business Days from 8am to 6pm Pacific time (P1 support
        available)
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "TermsOfService",
};
</script>

<style scoped></style>
